module.exports = __webpack_public_path__ + "fonts/Circe-Bold.e45ee535.woff2";